import { render, staticRenderFns } from "./Map-3-lands.vue?vue&type=template&id=1823bc72&"
import script from "./Map-3-lands.vue?vue&type=script&lang=js&"
export * from "./Map-3-lands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports